import { cn } from '@goaltree/ui/lib/utils'

import { BrandMark } from '@/components/brand-mark'

// App-wide loading splash: the Goaltree mark breathing on the app background,
// continuing the app icon instead of a bare spinner.
export default function Loader() {
  // Right after page load index.html's identical splash is already showing, so
  // fading in would make the mark blink out and back; later loads fade in so
  // quick ones don't flash it.
  const handoff = performance.now() < 5000
  return (
    <div
      className={cn('flex h-svh items-center justify-center', !handoff && 'splash')}
      role="status"
      aria-label="Loading"
    >
      <span className="relative flex items-center justify-center">
        <span className="splash-glow absolute size-24 rounded-full bg-primary/25 blur-2xl" />
        <BrandMark className="splash-mark relative size-14 rounded-2xl [&>svg]:size-8" />
      </span>
    </div>
  )
}
